import MasterCrudPage from "../../components/MasterCrudPage";
import { serviceCategoryApi } from "../../api/masterApi";

export default function ServiceCategory() {
  return (
    <MasterCrudPage
      title="Category Master"
      description="Add categories and manage them from the list below."
      idKey="service_category_id"
      api={serviceCategoryApi}
      listLabel="categories"
      hasImage
      imageField="service_category_image"
      fields={[
        {
          name: "service_category_name",
          label: "Category",
          type: "text",
          required: true,
          placeholder: "e.g. Reading & Predication Services",
        },
        {
          name: "applicable_to",
          label: "Applicable to",
          type: "radio",
          required: true,
          defaultValue: "Services",
          options: [
            { value: "Products", label: "Products" },
            { value: "Services", label: "Services" },
          ],
        },
        {
          name: "service_category_image",
          label: "Category Icon",
          type: "file",
        },
        {
          name: "sort_order",
          label: "Sort Order",
          type: "number",
          min: 0,
          step: "1",
          defaultValue: "0",
        },
        { name: "status", label: "Status", type: "checkbox" },
      ]}
      columns={[
        { key: "service_category_id", label: "Category" },
        { key: "service_category_name", label: "Category" },
        { key: "applicable_to", label: "Applicable to" },
        { key: "service_category_image", label: "Category Icon", type: "image" },
        { key: "sort_order", label: "Sort Order" },
        { key: "status", label: "Status", type: "status" },
      ]}
    />
  );
}
